
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handlePrivacyClick = () => {
    navigate('/datenschutz');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleImpressumClick = () => {
    navigate('/impressum');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-green-400" style={{ fontFamily: '"Pacifico", serif' }}>
              Jo Allround Service
            </h3>
            <p className="text-gray-300 mb-4">
              Ihr zuverlässiger Partner für alle Handwerksarbeiten, Renovierungen und kreative Lösungen.
            </p>
            <div className="flex space-x-4">
              <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full cursor-pointer hover:bg-green-700">
                <i className="ri-phone-line text-white"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full cursor-pointer hover:bg-green-700">
                <i className="ri-mail-line text-white"></i>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-green-400">Leistungen</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Trockenbau</li>
              <li>Gartenarbeiten</li>
              <li>Fliesenarbeiten</li>
              <li>Wandgestaltung</li>
              <li>Fenster & Türmontage</li>
              <li>Kleinreparaturen</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                Büro: 0175 / 7 44 30 33
              </li>
              <li className="flex items-center">
                <i className="ri-smartphone-line mr-2"></i>
                Außendienst: 0160 / 117 29 60
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info.joallround@gmail.com
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center text-gray-400">
          <p>&copy; 2025 Jo Allround Service. Alle Rechte vorbehalten.</p>
          <a 
            href="https://www.bamme-media.de" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-green-400 transition-colors cursor-pointer"
          >
            Made with Bamme-Media
          </a>
          <div className="mt-4 sm:mt-0 flex gap-6">
            <button
              onClick={handlePrivacyClick}
              className="text-gray-400 hover:text-green-400 transition-colors cursor-pointer"
            >
              Datenschutzerklärung
            </button>
            <button
              onClick={handleImpressumClick}
              className="text-gray-400 hover:text-green-400 transition-colors cursor-pointer"
            >
              Impressum
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
